import { LitElement, html } from 'lit';
import '../icons/info-icon.js';

class QuotePending extends LitElement {
    static properties = {
        quoteReference: { type: String },
    };

    createRenderRoot() {
        return this; // Light DOM for Tailwind compatibility
    }

    constructor() {
        super();
        this.quoteReference = '';
    }

    _handleRetry() {
        this.dispatchEvent(
            new CustomEvent('retry-fetch', {
                bubbles: true,
                composed: true,
            })
        );
    }

    render() {
        return html`
            <div class="hero min-h-[50vh] bg-base-200 rounded-lg">
                <div class="hero-content text-center">
                    <div class="max-w-lg">
                        <h1 class="text-3xl font-bold mb-4">Quote In Preparation</h1>
                        <p class="mb-6">
                            Quote <strong>${this.quoteReference}</strong> is being prepared and
                            isn't quite ready for review yet.
                        </p>
                        <div class="alert alert-row alert-info mb-6">
                            <info-icon class="shrink-0"></info-icon>
                            <span class="text-sm text-left">
                                Please check back shortly. If you've been waiting a while, feel free
                                to contact us for assistance.
                            </span>
                        </div>
                        <div class="flex gap-3 justify-center flex-wrap">
                            <button @click="${this._handleRetry}" class="btn btn-primary">
                                Try Again
                            </button>
                            <a
                                href="mailto:info@reach.nz?subject=Quote%20Acceptance:%20Quote%20Pending%20-%20${this
                                    .quoteReference}"
                                class="btn btn-outline"
                            >
                                Contact Support
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('quote-pending', QuotePending);
